import { render } from "./FiltersSort.vue?vue&type=template&id=629844aa"
import script from "./FiltersSort.vue?vue&type=script&lang=js"
export * from "./FiltersSort.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__